import { useEffect, useState } from 'react'
import './base.css'
import CloseIcon from '@mui/icons-material/Close';

const hiddenStyle = {
    opacity: 0,
    visibility: 'hidden',
    zIndex: -1
}

const showStyle = {
    opacity: 1,
    visibility: 'visible',
    zIndex: 1200
}

const BaseModal = ({ open, children, closeModal, className, footer }) => {
    const [style, setStyle] = useState(hiddenStyle)

    useEffect(() => {
        open ?
            setStyle(showStyle) :
            setTimeout(() => {
                setStyle(hiddenStyle)
            }, 200)
    }, [open])

    return (
        <div className={'base-modal-container' + (open ? ' active ' : ' hidden ') + (className ? className : '')} style={style}>
            <div className="base-modal-container__background" onClick={closeModal}></div>
            <div className="base-modal">
                <div className="base-modal__header">
                <span onClick={closeModal} style={{cursor:"pointer"}}>
                    <CloseIcon />
                </span>
                </div>
                <div className="base-modal__content">{children}</div>
                <div className='base-modal-footer'>{footer}</div>
            </div>
            
        </div>
    )
}

export default BaseModal